module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "display-image"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#toc6",
      "id": "toc6a"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p001-001.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "fb-title"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#toc7",
      "id": "toc7a"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("H")]), _vm._v("ow do we assess a person’s life? Do we ask how successful the person was in terms of fame, achievement, acquisitions, or relationships? Do we consider what major problems that person faced with health, family, career, or society?")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Yet even after these questions are answered, other fundamental ones remain: Was the person happy? Did the person treat others ethically? Did the person live well?")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Many philosophers suppose that answers to this second set of questions depend on answers to the first. Our view, however, is that the two sets are independent. In other words, morality, happiness, and quality of life do not follow from activities, accomplishments, or acclaim.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Note that we do not defend a specific moral theory. Instead, we assume that any moral person cares about others, treats them with respect, and seeks to minimize their suffering. Further complications abound, but these are not our focus.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("Nor do we distinguish various terms that indicate that a person’s whole life should be viewed positively. Thus we treat as synonymous “achieving well-being,” “attaining meaning,” and “living well,” although most often we refer to the last.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("Instead, we ask what are the connections between morality, happiness, and living well? Our answer is that moral behavior is not necessary for happiness and does not ensure it. Morality and happiness, however, are needed for living well, and together suffice to achieve that goal.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("We shall explain this view and defend it against arguments of those contemporary philosophers who disagree with us. We include historical references, but unlike many others who have written on these topics, we do not present our ideas as commentary on the writings of Plato or Aristotle. We do, however, link our position to elements within both the Hellenistic and Hebraic traditions.")]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_vm._v("We begin by considering reflections on the good life offered by the late political and legal theorist Ronald Dworkin. Although we do not find his conclusions persuasive, his presentation offers a convenient gateway to discussion of our main subject.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee45c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 75
// module chunks = 0